import { Theme } from "@mui/material/styles";
import { RADIUS } from "../shape";

export default function Modal(theme: Theme) {
  return {
    MuiModal: {
      styleOverrides: {
        root: {
          border: "none !important",
          outline: "none !important",
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: RADIUS.modal,
          boxShadow: theme.customShadows.modal,
          // intencional: a sombra de modal do redesign substitui o gradiente de elevação do MUI (Paper já faz o mesmo)
          backgroundImage: "none",
        },
      },
    },
  };
}
